import { InternalMessageBusChannels } from "sb-resp-lib";
import { IMessageBus } from "..";

export class ToggleTabEvent {
    private readonly messageBus: IMessageBus;
    private readonly blockId: string;

    private hasData: boolean;

    constructor(messageBus: IMessageBus, blockId: string) {
        this.messageBus = messageBus;
        this.blockId = blockId;
        this.hasData = true;
    }

    emit(elements: Array<any>, parentBlockId: string) {
        const hasData = elements.length > 0;
        if (this.hasData !== hasData) {
            this.hasData = hasData;
            this.messageBus.emit(InternalMessageBusChannels.legacy.tabSwitcher.showHideTab, !hasData, parentBlockId, this.blockId);
        }
    }

    reset = () => this.hasData = true;
}